module.exports = __webpack_public_path__ + "static/media/10.8aff5aa.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/10.wav
// module id = r/yS
// module chunks = 0